import { createSlotRecipe } from './runtime.js';

const headerConfig = {"name":"header","slots":["root","left","right","center","title"],"defaultVariants":{"size":"md"},"variantMap":{"hideBorder":["true"],"size":["md","sm","xs"]}}

export const header = /* @__PURE__ */ createSlotRecipe(headerConfig)